/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  UpdateWorkflowDto,
  WorkflowsControllerCreateWorkflowBody,
  WorkflowsControllerCreateWorkflowPathParameters,
  WorkflowsControllerDeleteWorkflowPathParameters,
  WorkflowsControllerExceedWorkflowPathParameters,
  WorkflowsControllerGetWorkflowPathParameters,
  WorkflowsControllerGetWorkflowsPathParameters,
  WorkflowsControllerUpdateWorkflowPathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class WorkflowsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all workflows for a client and device
   */

  getWorkflows<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: WorkflowsControllerGetWorkflowsPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows`);
  }
  /**
   * @summary Create a new workflow
   */

  createWorkflow<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: WorkflowsControllerCreateWorkflowPathParameters,
    workflowsControllerCreateWorkflowBody: WorkflowsControllerCreateWorkflowBody,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows`, workflowsControllerCreateWorkflowBody);
  }
  /**
   * @summary Retrieve a specific workflow
   */

  getWorkflow<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
    id,
  }: WorkflowsControllerGetWorkflowPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows/${id}`);
  }
  /**
   * @summary Update a workflow
   */

  updateWorkflow<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId, id }: WorkflowsControllerUpdateWorkflowPathParameters,
    updateWorkflowDto: UpdateWorkflowDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows/${id}`, updateWorkflowDto);
  }
  /**
   * @summary Delete a workflow
   */

  deleteWorkflow<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
    id,
  }: WorkflowsControllerDeleteWorkflowPathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows/${id}`);
  }
  /**
   * @summary Exceed a workflow
   */

  exceedWorkflow<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
    id,
  }: WorkflowsControllerExceedWorkflowPathParameters): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/workflows/${id}/exceed`, undefined);
  }
}
